import { isServerside } from '../../../../utils/isServerside';

export const getDealsPerPage = (): number => {
  if (!isServerside() && window.matchMedia('only screen and (max-width: 800px)').matches) return 2;
  return 4;
};
